
import { auth } from "firebaseConfig";
import { signOut } from "firebase/auth";

export function logout(): void {
    try { signOut(auth) } catch (err) { return }
}

